import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #916ee8;
  height: 18px;
  width: 18px;
`
export const ArchiveIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19" className={className}>
      <path d="M1.5 18.5C1.1 18.5 0.75 18.35 0.45 18.05C0.15 17.75 0 17.4 0 17V3.925C0 3.675 0.025 3.4625 0.075 3.2875C0.125 3.1125 0.216667 2.95 0.35 2.8L1.75 0.9C1.88333 0.75 2.0375 0.645833 2.2125 0.5875C2.3875 0.529167 2.59488 0.5 2.83465 0.5H15.1654C15.4051 0.5 15.6083 0.529167 15.775 0.5875C15.9417 0.645833 16.0917 0.75 16.225 0.9L17.65 2.8C17.7833 2.95 17.875 3.1125 17.925 3.2875C17.975 3.4625 18 3.675 18 3.925V17C18 17.4 17.85 17.75 17.55 18.05C17.25 18.35 16.9 18.5 16.5 18.5H1.5ZM1.925 3.15H16.05L15.1398 2H2.825L1.925 3.15ZM1.5 4.65V17H16.5V4.65H1.5ZM9 14.75L12.9 10.85L11.9 9.85L9.75 12V6.975H8.25V12L6.1 9.85L5.1 10.85L9 14.75Z" />
    </Svg>
  )
}
